module.exports = __webpack_public_path__ + "img/new_index_service_icon3.8633e67d.png";